import { TabPanel, TabView } from 'primereact/tabview';
import React, { useState } from 'react';
import MasterWipScreen from './MasterWipScreen';
import PriorityListScreen from './PriorityListScreen';
import PastDueListScreen from './PastDueListScreen';
import { Button } from 'primereact/button'
import TimeLine from '../../../Base/Components/TimeLine/TimeLine';
import PlannerMasterWipScreen from './PlannerMasterWipScreen';

const WIPScreen = () => {

    const [index, setIndex] = useState(0);
    const [get, setGet] = useState(0);

    const statusTemplate = e => {
        let color = '';
        switch (e?.Estado) {
            case 'Exported':
                color = 'rgba(223,241,194';
                break;
            case 'Ready to Ship':
                color = 'rgba(86,189,55';
                break
            case 'Total Rejected':
                color = 'rgba(255,0,0';
                break
            case 'Washing':
                color = 'rgba(190,190,203';
                break
            case 'Dyed':
                color = 'rgba(245,194,193)';
                break
            case 'In Process':
                color = 'rgba(205,253,254)';
                break
            case 'Finishing':
                color = 'rgba(151,204,246)';
                break
            case 'Pending Batch':
                color = 'rgba(223,209,188)';
                break
            case 'QC':
                color = 'rgba(249,217,73)';
                break
            case 'QC Revision':
                color = 'rgba(249,217,73)';
                break
            case 'Batched':
                color = 'rgba(205, 253, 197)';
                break
            case 'Receive in Batching':
                color = 'rgba(216,185,141)';
                break
            default:
                color = 'rgba(255,255,255)';
                break;
        }
        if (e?.Estado) {
            return <div className='d-flex gap' style={{ alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <div style={{ backgroundColor: color, width: '100%', height: '100%' }}>
                    <div className='text-bold text-center text-black'>{e.Estado}</div>
                </div>
            </div>
        }
    }

    return (
        <div>
            <TabView onTabChange={(e) => setIndex(e.index)} activeIndex={index}>
                <TabPanel header={
                    <div className='d-flex gap' style={{ justifyContent: 'center', alignItems: 'center' }} >
                        <div>
                            Ready to Ship (Past Due)
                        </div>
                        {index === 0 ? <Button icon='pi pi-refresh' text onClick={e => setGet(get + 1)} /> : <Button text />}
                    </div>}>
                    <PastDueListScreen get={get} statusTemplate={statusTemplate} />
                </TabPanel>
                <TabPanel header={
                    <div className='d-flex gap' style={{ justifyContent: 'center', alignItems: 'center' }} >
                        <div>
                            Priority List
                        </div>
                        {index === 1 ? <Button icon='pi pi-refresh' text onClick={e => setGet(get + 1)} /> : <Button text />}
                    </div>}>
                    <PriorityListScreen get={get} statusTemplate={statusTemplate} />
                </TabPanel>
                <TabPanel
                    header={
                        <div className='d-flex gap' style={{ justifyContent: 'center', alignItems: 'center' }} >
                            <div>
                                Master WIP
                            </div>
                            {index === 2 ? <Button icon='pi pi-refresh' text onClick={e => setGet(get + 1)} /> : <Button text />}
                        </div>}
                >
                    <MasterWipScreen get={get} statusTemplate={statusTemplate} />
                </TabPanel>

            </TabView>
        </div>
    )
}

export default WIPScreen